'use client';

const assets = [
  { name: 'auth-server-01', type: 'Server', status: 'critical', alerts: 7, score: 91 },
  { name: 'webapp-prod-02', type: 'Web App', status: 'high', alerts: 3, score: 72 },
  { name: 'core-dns-01', type: 'DNS', status: 'critical', alerts: 5, score: 88 },
  { name: 'dmz-fw-01', type: 'Firewall', status: 'medium', alerts: 2, score: 44 },
  { name: 'rdp-gateway-01', type: 'Gateway', status: 'high', alerts: 4, score: 67 },
  { name: 'workstation-hr-14', type: 'Workstation', status: 'critical', alerts: 1, score: 95 },
];

const statusBar: Record<string, string> = {
  critical: 'bg-red-500',
  high: 'bg-orange-500',
  medium: 'bg-amber-500',
  low: 'bg-blue-500',
  online: 'bg-emerald-500',
};

export default function AssetHealthPanel() {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-200">Risk Altındaki Varlıklar</h3>
        <a href="/network-assets" className="text-xs text-rose-400 hover:text-rose-300 transition-colors font-medium">Tümünü gör →</a>
      </div>
      <div className="space-y-2.5">
        {assets.map((a) => (
          <div key={a.name} className="flex items-center gap-2.5">
            <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${statusBar[a.status]}`} />
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-zinc-300 truncate">{a.name}</span>
                <span className="text-[10px] text-zinc-600 ml-2 flex-shrink-0">{a.alerts} alarm</span>
              </div>
              <div className="mt-1 h-1 bg-zinc-800 rounded-full overflow-hidden">
                <div
                  className={`h-full rounded-full transition-all ${statusBar[a.status]}`}
                  style={{ width: `${a.score}%`, opacity: 0.7 }}
                />
              </div>
            </div>
            <span className="font-mono text-xs font-semibold text-zinc-400 w-8 text-right flex-shrink-0">{a.score}</span>
          </div>
        ))}
      </div>
    </div>
  );
}